import { ChangeDetectorRef, Directive, Input, OnChanges } from '@angular/core';

@Directive()
export class ProfilePicBaseComponent implements OnChanges {
    @Input() size!: 'small' | 'large';
    @Input() imageUrl!: string;
    @Input() initials!: string;
    isImageValid: boolean | any = false;
    @Input() noProfilePic: boolean = true;

    constructor(private cdr: ChangeDetectorRef) {
    }

    ngOnChanges(): void {
        this.ensureImage();
    }

    ensureImage(): void {
        if (!this.imageUrl) return;
        const image = new Image();
        image.src = this.imageUrl;
        image.onload = () => {
            this.setImageValidationStatus(true);
        };
        image.onerror = () => {
            this.setImageValidationStatus(false);
        };
        image.src = this.imageUrl;
    }


    setImageValidationStatus(status: boolean) {
        this.isImageValid = status;
        this.cdr.detectChanges();
    }
}
